import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { ActionBar, QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { ProductListCard } from '../components/ProductsListCard';
import { ProductSubtypeDeleteCard } from './components/ProductSubtypeDeleteCard';
import { ProductSubtypeDetailsCard } from './components/ProductSubtypeDetailsCard';

export function ProductSubtypeDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const productSubtypeQueryResults = useQuery({
        queryKey: ['productSubtype', id],
        queryFn: () => Api.Products.Subtypes.getProductSubtype(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={productSubtypeQueryResults}>
                {data => {
                    return (
                        <>
                            <ActionBar
                                breadcrumbs={[
                                    {
                                        display: 'Admin',
                                        to: '/admin',
                                    },
                                    {
                                        display: 'Alcohol Subtypes',
                                        to: '/products/subtypes',
                                    },
                                    {
                                        display: 'Details',
                                        active: true,
                                    },
                                ]}
                            />
                            <Stack gap={2} sx={{ paddingBottom: 4 }}>
                                <ProductSubtypeDetailsCard
                                    productSubtype={data}
                                />
                                <ProductListCard
                                    products={data.products}
                                    refetch={productSubtypeQueryResults.refetch}
                                />

                                {!data.products.length && (
                                    <Can I="delete" a="Alcohol">
                                        <ProductSubtypeDeleteCard
                                            productSubtype={data}
                                        />
                                    </Can>
                                )}
                            </Stack>
                        </>
                    );
                }}
            </QueryRenderer>
        </RootContainer>
    );
}
